import { INotification, notificationEnums } from "@freetech/models/notifications";

export const getNotificationSeverity = (notification: INotification): "info" | "success" | "warning" | "error" => {
  const { type, afterData } = notification;

  if (Object.values(notificationEnums.StakeholderNotificationType).includes(type as any)) {
    switch (type) {
      case notificationEnums.StakeholderNotificationType.STAKEHOLDER_PAYMENT_COMPLETED:
      case notificationEnums.StakeholderNotificationType.STAKEHOLDER_INVOICE_PAID:
        return "success";
      case notificationEnums.StakeholderNotificationType.STAKEHOLDER_PAYMENT_FAILED:
        return "error";
      case notificationEnums.StakeholderNotificationType.STAKEHOLDER_PAYMENT_REVERSED:
        return "warning";
      case notificationEnums.StakeholderNotificationType.STAKEHOLDER_INVOICE_RECIEVED:
      case notificationEnums.StakeholderNotificationType.STAKEHOLDER_CSA_RECIEVED:
      case notificationEnums.StakeholderNotificationType.STAKEHOLDER_PAYMENT_CREATED:
        return "info";
    }
  }

  if (Object.values(notificationEnums.FreelancerNotificationType).includes(type as any)) {
    switch (type) {
      case notificationEnums.FreelancerNotificationType.FREELANCER_PAYMENT_CREATED:
      case notificationEnums.FreelancerNotificationType.FREELANCER_PROJECT_ASSIGNMENT_CREATED:
      case notificationEnums.FreelancerNotificationType.FREELANCER_PROJECT_ASSIGNMENT_COMPLETED:
      case notificationEnums.FreelancerNotificationType.FREELANCER_ONBOARDING_COMPLETE:
        return "success";
      case notificationEnums.FreelancerNotificationType.FREELANCER_AGREEMENT_REMINDER:
        return "warning";
      case notificationEnums.FreelancerNotificationType.FREELANCER_PAYMENT_UPDATED:
        if (afterData && 'status' in afterData) {
          if (afterData.status === 'completed') return "success";
          if (afterData.status === 'failed') return "error";
          if (afterData.status === 'pending_approval') return "warning";
        }
        return "info";
      case notificationEnums.FreelancerNotificationType.FREELANCER_AGREEMENT_CREATED:
        return "info";
    }
  }

  if (Object.values(notificationEnums.AdminNotificationType).includes(type as any)) {
    switch (type) {
      case notificationEnums.AdminNotificationType.ADMIN_USER_CREATED:
      case notificationEnums.AdminNotificationType.ADMIN_CLIENT_CREATED:
      case notificationEnums.AdminNotificationType.ADMIN_PROJECT_CREATED:
      case notificationEnums.AdminNotificationType.ADMIN_CSA_CREATED:
      case notificationEnums.AdminNotificationType.ADMIN_INVOICE_CREATED:
      case notificationEnums.AdminNotificationType.ADMIN_PAYMENT_CREATED:
      case notificationEnums.AdminNotificationType.ADMIN_PROJECT_ASSIGNMENT_CREATED:
      case notificationEnums.AdminNotificationType.ADMIN_TIMESHEET_CREATED:
      case notificationEnums.FreeloNotificationType.FREELO_BOARD_CREATED:
        return "success";

      case notificationEnums.AdminNotificationType.ADMIN_PAYMENT_COMPLETED:
      case notificationEnums.AdminNotificationType.ADMIN_INVOICE_PAID:
      case notificationEnums.AdminNotificationType.ADMIN_CSA_SIGNED_BY_ADMIN:
      case notificationEnums.AdminNotificationType.ADMIN_CSA_SIGNED_BY_STAKEHOLDER:
      case notificationEnums.AdminNotificationType.ADMIN_PROJECT_ASSIGNMENT_SIGNED:
      case notificationEnums.AdminNotificationType.ADMIN_TIMESHEET_APPROVED:
      case notificationEnums.AdminNotificationType.ADMIN_USER_ONBOARDING_COMPLETE:
        return "success";

      case notificationEnums.AdminNotificationType.ADMIN_TIMESHEET_REJECTED:
      case notificationEnums.FreeloNotificationType.FREELO_BOARD_DELETED:
        return "error";

      case notificationEnums.AdminNotificationType.ADMIN_TIMESHEET_SUBMITTED:
      case notificationEnums.AdminNotificationType.ADMIN_USER_SIGNED_UP:
        return "warning";

      case notificationEnums.AdminNotificationType.ADMIN_PAYMENT_STATUS_CHANGED:
        if (afterData && 'status' in afterData) {
          if (afterData.status === 'completed') return "success";
          if (afterData.status === 'failed') return "error";
          if (afterData.status === 'pending_approval') return "warning";
        }
        return "info";

      case notificationEnums.AdminNotificationType.ADMIN_CLIENT_UPDATED:
      case notificationEnums.AdminNotificationType.ADMIN_PROJECT_UPDATED:
      case notificationEnums.FreeloNotificationType.FREELO_BOARD_UPDATED:
        return "info";
    }
  }

  if (Object.values(notificationEnums.FreeloNotificationType).includes(type as any)) {
    switch (type) {
      case notificationEnums.FreeloNotificationType.FREELO_CARD_CREATED:
      case notificationEnums.FreeloNotificationType.FREELO_CARD_ASSIGNED:
        return "success";
      case notificationEnums.FreeloNotificationType.FREELO_CARD_DELETED:
        return "error";
      case notificationEnums.FreeloNotificationType.FREELO_DEADLINE_APPROACHING:
        return "warning";
      case notificationEnums.FreeloNotificationType.FREELO_CARD_UPDATED:
      case notificationEnums.FreeloNotificationType.FREELO_CARD_STATUS_CHANGED:
      case notificationEnums.FreeloNotificationType.FREELO_CARD_COMMENT_MENTION:
        return "info";
    }
  }

  return "info";
}; 